export default __webpack_public_path__ + "static/broadcastBg-3d0d506498f82d78d50b5015ce35af9c.png";